var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "select-startstop" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "block my-6" }),
    _vm._v(" "),
    _c("div", { staticClass: "tile is-ancestor" }, [
      _c("div", { staticClass: "tile" }, [
        _c("div", { staticClass: "tile" }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tile mx-6 is-parent",
            on: {
              click: function($event) {
                return _vm.start_clicked()
              }
            }
          },
          [
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-success",
                  rounded: "",
                  expanded: "",
                  size: "is-large"
                }
              },
              [_vm._v(" 開始 ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "tile mx-6 is-parent",
            on: {
              click: function($event) {
                return _vm.stop_clicked()
              }
            }
          },
          [
            _c(
              "b-button",
              {
                attrs: {
                  type: "is-success",
                  rounded: "",
                  expanded: "",
                  size: "is-large"
                }
              },
              [_vm._v(" 終了 ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tile" })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "title-bar" }, [
      _c("div", { staticClass: "hero-body" }, [
        _c("p", { staticClass: "title" }, [_vm._v("作業の開始/終了")]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v("作業の「開始」か「終了」を選択してください")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b867c830", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b867c830","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectStartStop.vue
// module id = Hhgd
// module chunks = 0